import closeIcon from "assets/icons/close.svg";
import infoIcon from "assets/icons/info.svg";
import Emails from "components/ShareDocuments/Emails";
import React from 'react';


const tabs = [
  {
    id: "email",
    label: "Email",
  },
  {
    id: "text",
    label: "Text",
  },
];

const SendLetterHeader = ({
  savedEmails,
  setSavedEmails,
  closeModal,
  setActiveTab,
  activeTab,
  title,
  isMultiple,
  withoutCloseIcon,
  className,
  disableAddingToEmails
}) => {


  const selectTabHandler = (tabId) => {
    setActiveTab(tabId);
  };


  return (
    <div className= {`send-letter__content__header ${className}`}>
      {/* <div className="send-letter__content__header__tabs">
        {tabs.map((tab) => (
        <div className={`send-letter__content__header__tabs-tab ${activeTab === tab.id ? "active" : ""}`} key={tab.id} onClick={() => selectTabHandler(tab.id)}>
          {tab.label}
        </div>
        ))}
      </div> */}
      <div className="send-letter__content__header-title">
        <h2>{title}</h2>
        <img src={infoIcon} alt="info" />
      </div>
      <Emails
        setSavedEmails={setSavedEmails}
        savedEmails={savedEmails}
        disableAddingToEmails={disableAddingToEmails || isMultiple}
        defaultToEmailText={isMultiple ? "Bulk recipients" : ""}
      />
      <div className="send-letter-close"
        onClick={closeModal}
      >
         {!withoutCloseIcon &&<img src={closeIcon} alt="" />}
      </div>
    </div>
  )
}

export default SendLetterHeader